module.exports = __webpack_public_path__ + "img/icon-question-rating-radio_button.6c32b440.svg";